/**
 * Quantities come back from the API as DECIMAL strings ("50.0000"). Show them without trailing
 * zeros: "50", "1.5", "0.25". Empty or non-numeric values give "-".
 */
export function formatQuantity(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "-"
  const n = typeof value === "number" ? value : Number(value)
  if (!Number.isFinite(n)) return "-"
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 4, useGrouping: false }).format(n)
}
